import { AnomalyAnalyzerService } from '@ids-services';
import { AfterViewInit, Component, signal, ViewChild } from '@angular/core';
import { BaseComponent, CardComponent, FormBuilderComponent, LoadingOverlayComponent } from '@microsec/components';
import { FormItem } from '@microsec/models';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { finalize } from 'rxjs';

const FORM_PARAMS = {
  USERNAME: 'read_only_username',
  PASSWORD: 'read_only_password',
  TIP_URL: 'tip_url',
};

@Component({
  selector: 'app-tip-credentials',
  templateUrl: './tip-credentials.component.html',
  styleUrls: ['./tip-credentials.component.scss'],
  imports: [LoadingOverlayComponent, ButtonModule, CardComponent, InputGroupAddonModule, FormBuilderComponent],
})
export class TipCredentialsComponent extends BaseComponent implements AfterViewInit {
  isLoading = signal(false);

  fields = signal<FormItem[]>([]);

  config = signal<any>(null);

  @ViewChild('fb') form!: FormBuilderComponent;

  constructor(
    public anomalyAnalyzerSrv: AnomalyAnalyzerService,
    public ref: DynamicDialogRef,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.getCredentials();
  }

  initForm() {
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.USERNAME,
        label: 'Username',
        field: 'copy',
        placeholder: 'TIP Base URL',
        isMediumSize: true,
        disabled: true,
        defaultValue: '',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.PASSWORD,
        label: 'Password',
        field: 'copy-password',
        placeholder: 'TIP API Token',
        feedback: false,
        isMediumSize: true,
        disabled: true,
        defaultValue: '',
      } as FormItem),
    ];
    this.fields.set(fields);
  }

  getCredentials() {
    this.isLoading.set(true);
    this.anomalyAnalyzerSrv
      .getTipConfig()
      .pipe(
        finalize(() => {
          this.initForm();
          this.isLoading.set(false);
        }),
      )
      .subscribe({
        next: (response: any) => {
          this.form?.patchValue(response);
          this.config.set(response);
        },
        error: (err: any) => {
          this.showErrorMessage(err);
        },
      });
  }

  onProceed() {
    window.open(this.config()?.[FORM_PARAMS.TIP_URL], '_blank')?.focus();
  }

  onCancel() {
    this.ref.close(false);
  }
}
